import React, { useContext, useState } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { EditExerciseDialog } from "./EditExerciseDialog";
import useMediaQuery from "@mui/material/useMediaQuery";

export const SelectedExerciseItem = ({
  id,
  name,
  hold,
  repeat,
  timesperday,
  range,
  resistance,
  direction,
  bmname,
  instructions,
  onRemove,
  onChange,
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const img = require(`../../assets/exercise/${bmname}.png`);
  const { darkMode } = useContext(ThemeContext);

  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    onRemove(id);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true); // Open the dialog
  };

  const handleDialogClose = (e) => {
    e?.stopPropagation();
    setDialogOpen(false); // Close the dialog
  };

  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        width: "100%",
        height: { xs: "100px", sm: "120px" },
        padding: 1,
        borderRadius: "5px",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: darkMode
          ? getColors.thumbnailBorderDark
          : getColors.thumbnailBorderLight,
        background: darkMode
          ? getColors.thumbnnailBgDark
          : getColors.thumbnnailBgLight,
        cursor: "pointer",
        "&:hover": {
          borderColor: darkMode
            ? getColors.thumbnailTextDark
            : getColors.thumbnailTextLight,
        },
      }}
      onClick={handleDialogOpen}
    >
      <Box>
        <Box display={"flex"} alignItems={"center"}>
          <img
            src={img}
            alt="img"
            style={{
              width: isMobile ? "80px" : "100px",
              height: isMobile ? "60px" : "75px",
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: "18px", sm: "20px", md: "22px" },
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
              ml: "20px",

              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: "1.5em",
              maxHeight: "3em",
            }}
          >
            {name}
          </Typography>
        </Box>
        <Box display={"flex"} sx={{ mt: "4px" }}>
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "13px", md: "14px" },
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
              ml: "15px",
            }}
          >
            {`Hold=${hold}`}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "13px", md: "14px" },
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
              mx: { xs: "12px", sm: "16px", md: "20px" },
            }}
          >
            {`Repeat=${repeat}`}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "13px", md: "14px" },
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
            }}
          >
            {`PerDay=${timesperday}`}
          </Typography>
        </Box>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        width="max-content"
        sx={{
          borderRadius: "50%",
          padding: { xs: "10px", sm: "15px", md: "20px" },
          color: "#FF3D3D",
          bgcolor: "#FFE8E8",
          alignItems: "center",
          "&:hover": {
            color: "red",
          },
          ml: { xs: 1, sm: 2, md: 4 },
          mr: { xs: 0, sm: 1, md: 2 },
        }}
        onClick={handleClick}
      >
        <DeleteOutlinedIcon sx={{ fontSize: { xs: "23px", md: "30px" } }} />
      </Box>
      <EditExerciseDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onSave={(value) => onChange(value)}
        exerciseData={{
          id,
          name,
          hold,
          repeat,
          timesperday,
          range,
          resistance,
          direction,
          bmname,
          instructions,
        }}
      />
    </Box>
  );
};
